


















































































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import FilterToggle from '@/components/FilterToggle.vue'
import FilterSocialType from '@/components/filters/FilterSocialType.vue'
import {SocialType} from '@/model/resource/SocialType'
import {SocialTypeCollection} from '@/model/collection/SocialTypeCollection'
import {ListSocialTypeSchema} from '@/schema/resource/SocialType/ListSocialTypeSchema'
import {ExportSocialTypeSchema} from '@/schema/resource/SocialType/ExportSocialTypeSchema'

@Component({
  components: {FilterToggle, FilterSocialType},
})
export default class ListSocialTypeView extends Mixins(MixinRouteMatch) {
  schema = new ListSocialTypeSchema()
  collection = new SocialTypeCollection()
  filterOpen = false

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }
    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }

  goToPersistView(item: SocialType) {
    this.$nav.pushByName('editSocialType', item.$id)
  }

  async removeItem(item: SocialType) {
    await this.$dialog.remove(item)
    await item.removeSocialType()
    await this.collection.queryAsPage()
  }

  async downloadXlsx() {
    const {...params} = this.collection.params

    const coll = new SocialTypeCollection().clearFilters().addFilter(params)

    await coll.listExportSocialType()
    this.$xlsx.downloadFromSchema(coll.items, new ExportSocialTypeSchema())
  }
}
